/* assets/vpv-nav.js */
(function () {
  "use strict";

  // Match your CSS breakpoints. Your mobile code used max-width:1000px.
  const MOBILE_MQ = window.matchMedia("(max-width: 1000px)");

  // ===== tiny helpers =====
  function addScript(src) {
    return new Promise((resolve, reject) => {
      if ([...document.scripts].some(s => s.src === src)) return resolve();
      const s = document.createElement("script");
      s.src = src; s.defer = true;
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function addStyle(href) {
    if ([...document.styleSheets].some(ss => ss.href === href)) return;
    const l = document.createElement("link");
    l.rel = "stylesheet"; l.href = href;
    document.head.appendChild(l);
  }

  // ===== desktop module =====
  let desktop = {
    _root: null,
    _onKeydown: null,
    _onDocClick: null,
    _onBlur: null,

    init() {
      // Scope to the header section if present, otherwise document.
      this._root = document;
      const nav = this._root;
      const toggles = nav.querySelectorAll("[data-acc-nav-toggle]");
      const panels  = nav.querySelectorAll("[data-acc-nav-panel]");
      if (!toggles.length || !panels.length) return; // nothing to do

      function closeAll(exceptId) {
        panels.forEach((p) => {
          if (!exceptId || p.id !== exceptId) p.hidden = true;
        });
        toggles.forEach((t) => {
          const cid = t.getAttribute("aria-controls");
          if (!exceptId || cid !== exceptId) t.setAttribute("aria-expanded", "false");
        });
      }

      function togglePanel(btn) {
        const id = btn.getAttribute("aria-controls");
        const panel = nav.querySelector("#" + CSS.escape(id));
        if (!panel) return;
        const willOpen = panel.hidden;
        closeAll(willOpen ? id : null);
        panel.hidden = !willOpen;
        btn.setAttribute("aria-expanded", String(willOpen));
        if (willOpen) {
          const first = panel.querySelector("a, button, [tabindex]:not([tabindex='-1'])");
          if (first) first.focus({ preventScroll: true });
        } else {
          btn.focus({ preventScroll: true });
        }
      }

      // Click handlers (idempotent: remove existing first)
      toggles.forEach((btn) => {
        btn.__vpvBound && btn.removeEventListener("click", btn.__vpvBound);
        btn.__vpvBound = (e) => { e.preventDefault(); togglePanel(btn); };
        btn.addEventListener("click", btn.__vpvBound);
      });

      // Keyboard nav
      this._onKeydown = (e) => {
        const active = document.activeElement;
        if (active && active.matches("[data-acc-nav-toggle]")) {
          const items = Array.from(toggles);
          const idx = items.indexOf(active);
          if (e.key === "ArrowRight") { e.preventDefault(); (items[idx + 1] || items[0]).focus(); }
          else if (e.key === "ArrowLeft") { e.preventDefault(); (items[idx - 1] || items[items.length - 1]).focus(); }
          else if (e.key === "Escape") { closeAll(); active.focus(); }
          else if (e.key === "Enter" || e.key === " ") { e.preventDefault(); togglePanel(active); }
        } else if (e.key === "Escape") {
          closeAll();
        }
      };
      nav.addEventListener("keydown", this._onKeydown);

      // Click outside closes
      this._onDocClick = (e) => { if (!nav.contains(e.target)) closeAll(); };
      document.addEventListener("click", this._onDocClick);

      // Window blur closes
      this._onBlur = () => closeAll();
      window.addEventListener("blur", this._onBlur);
    },

    teardown() {
      const nav = this._root || document;
      // Remove per-button handlers
      nav.querySelectorAll("[data-acc-nav-toggle]").forEach((btn) => {
        if (btn.__vpvBound) {
          btn.removeEventListener("click", btn.__vpvBound);
          btn.__vpvBound = null;
        }
      });
      if (this._onKeydown) nav.removeEventListener("keydown", this._onKeydown);
      if (this._onDocClick) document.removeEventListener("click", this._onDocClick);
      if (this._onBlur) window.removeEventListener("blur", this._onBlur);
      this._onKeydown = this._onDocClick = this._onBlur = null;
      this._root = null;
    }
  };

  // ===== mobile module (MmenuLight) =====
  let mobile = {
    _drawer: null,
    _opener: null,
    async init() {
      const menuEl = document.querySelector("#tushy-global-nav-mobile");
      const opener = document.querySelector("a[href='#tushy-global-nav-mobile']");
      if (!menuEl || !opener) return;

      // Ensure library (lazy load only on mobile)
	  if (typeof window.MmenuLight === "undefined") {
	    if (window.VPV_ASSETS?.mmenuCss) addStyle(window.VPV_ASSETS.mmenuCss);
	    if (window.VPV_ASSETS?.mmenuJs)  await addScript(window.VPV_ASSETS.mmenuJs);
	  }
    

      const menu = new window.MmenuLight(menuEl, "(max-width: 1000px)");
      menu.navigation(); // returns API, not needed here
      this._drawer = menu.offcanvas();

      // bind opener (idempotent)
      if (opener.__vpvOpen) opener.removeEventListener("click", opener.__vpvOpen);
      opener.__vpvOpen = (ev) => { ev.preventDefault(); this._drawer.open(); };
      opener.addEventListener("click", opener.__vpvOpen);
      this._opener = opener;
    },

    teardown() {
      // MmenuLight has no explicit destroy; unbind our opener and close drawer.
      if (this._opener && this._opener.__vpvOpen) {
        this._opener.removeEventListener("click", this._opener.__vpvOpen);
        this._opener.__vpvOpen = null;
      }
      try { this._drawer && this._drawer.close && this._drawer.close(); } catch(_) {}
      this._drawer = null; this._opener = null;
    }
  };

  // ===== mode switcher =====
  let current = null; // "mobile" | "desktop"

  async function applyMode() {
    const want = MOBILE_MQ.matches ? "mobile" : "desktop";
    if (want === current) return;
    // teardown previous
    if (current === "mobile") mobile.teardown();
    if (current === "desktop") desktop.teardown();

    // init next
    if (want === "mobile") await mobile.init();
    else desktop.init();

    current = want;
  }

  // Run now + on changes + in Theme Editor
  function boot() { applyMode().catch(() => {}); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
  MOBILE_MQ.addEventListener("change", applyMode);
  document.addEventListener("shopify:section:load", applyMode);
  document.addEventListener("shopify:section:select", applyMode);
})();
